import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee, Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { Fleet } from "@/components/site/Fleet";
import { Standards } from "@/components/site/Standards";
import { Destinations, Aviation } from "@/components/site/Destinations";
import { Corporate, Partners } from "@/components/site/CorporatePartners";
import { Journeys, Pillars, About } from "@/components/site/Journeys";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <main>
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Services />
      <Fleet />
      <Standards />
      <Destinations />
      <Aviation />
      <Corporate />
      <Partners />
      <Journeys />
      <Pillars />
      <About />
      <Footer />
    </main>
  );
}
